import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_FAIR_CODE } from './gql/getFairCode';

type QueryDataType = Pick<Query, 'getFairCode'>;
type OutgoingDataType = QueryDataType['getFairCode'];

const onError = getErrorLoggerFunction('getFairCode');

export const useGetFairCode = () => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(GET_FAIR_CODE, {
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.getFairCode);
        }
    }, [data]);

    return {
        getFairCode: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
